import { RequestMethod } from "@/shared/utils/RequestMethod";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define la URL base para la API de RestCountries
const BASE_URL = "https://unpkg.com/country-state-city@3.1.4/lib/cjs/assets";

export const statesApi = createApi({
  reducerPath: "statesApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
  }),
  endpoints: (builder) => ({
    getAllStates: builder.query({
      query: () => "/state.json",
    }),
    states: builder.query({
      query: () => ({
        url: "/state.json",
        method: RequestMethod.GET,
      }),
      transformResponse: (response: any) =>
        response.map((state: any) => ({
          name: state.name,
          id: state.isoCode,
          isoCode: state.isoCode,
          countryCode: state.countryCode,
        })),
    }),
    timezones: builder.query({
      query: () => ({
        url: "/country.json",
        method: RequestMethod.GET,
      }),
      transformResponse: (response: any) =>
        response.map((state: any) => ({
          name: state.name,
          id: state.isoCode,
          code: state.isoCode,
          isoCode: state.isoCode,
          timezones: state.timezones,
        })),
    }),
  }),
});

// Exporta el hook para la consulta
export const { useGetAllStatesQuery, useStatesQuery, useTimezonesQuery } =
  statesApi;
